import { Accordion } from 'react-bootstrap';
const startScreenText = (): JSX.Element => {
  return (
    <div>
      <div className="summary-body tool-front">
        <p>
          This screening tool consists of frequency of use questions to categorize substance use by
          adolescent patients into different risk categories. The accompanying resources assist
          clinicians in providing patient feedback and resources for follow-up.
        </p>
      </div>

      <Accordion title="Screening Tool Cutoffs and Scoring Thresholds">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Screening Tool Cutoffs and Scoring Thresholds:</Accordion.Header>
          <Accordion.Body>
            <p>
              S2BI asks a single frequency question for past year’s use of the three substances most
              commonly used by adolescents: tobacco, alcohol, and marijuana. An affirmative response
              prompts questions about additional types of substances used. For each substance,
              responses can be categorized into levels of risk. Each risk level maps onto suggested
              clinical actions summarized on the results screen.
            </p>

            <table className="scoring-table s2bi">
              <thead>
                <tr>
                  <th>S2BI Response</th>
                  <th>Risk Category</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Never</td>
                  <td>No Reported Use</td>
                </tr>
                <tr>
                  <td>Once or twice</td>
                  <td>Lower Risk</td>
                </tr>
                <tr>
                  <td>Monthly+</td>
                  <td>Higher Risk</td>
                </tr>
              </tbody>
            </table>

            <h3 className="extra-padding-top">Tool Validation:</h3>

            <p>
              Psychometric properties for the S2BI tool were first described by Levy et al. in 2014.
              <sup>1</sup> S2BI was originally validated in a relatively small study in pediatric
              medical settings. In a recent study (2023) by Levy and colleagues found a high
              agreement between S2BI screening results and the criterion standard measure
              demonstrating additional psychometric validation.<sup>2</sup> The findings from this
              research are consistent with similar research in adults and support the principle of
              frequency-based screening as a good mechanism for detecting adolescents that are at
              high risk for substance use disorders.
            </p>

            <div className="footnote">
              <p>
                1. Levy, S., Weiss, R., Sherritt, L., Ziemnik, R., Spalding, A., Van Hook, S., &
                Shrier, L. A. (2014). An electronic screen for triaging adolescent substance use by
                risk levels. JAMA Pediatrics. 168(9), 822-828.{' '}
                <a
                  href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC4270364/"
                  target="_blank"
                  rel="noreferrer"
                >
                  http://www.ncbi.nlm.nih.gov/pmc/articles/PMC4270364/
                </a>
              </p>
              <p>
                2. Levy S, Brogna M, Minegishi M, Subramaniam G, McCormack J, Kline M, Menzin E,
                Allende-Richter S, Fuller A, Lewis M, Collins J, Hubbard Z, Mitchell SG, Weiss R,
                Weitzman E. Assessment of Screening Tools to Identify Substance Use Disorders Among
                Adolescents. JAMA Netw Open. 2023 May 1;6(5):e2314422. doi:
                10.1001/jamanetworkopen.2023.14422. PMID: 37213103; PMCID: PMC10203888.
              </p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <p className="summary-disclaimer">
        Intended use: This screening tool is meant to be used under a medical provider’s supervision
        and is not intended to guide self-assessment or take the place of a healthcare provider’s
        clinical judgment.
        <br />
        <br />
        This tool may be administered by either the patient or the clinician. Please indicate the
        mode of administration:
      </p>
    </div>
  );
};

export default startScreenText;
